var React = require('react');

function CopyInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 2H14.6667V16H2.66669V13","stroke":"currentColor","strokeWidth":"1.6","key":0}),React.createElement("rect",{"x":"0.8","y":"0.8","width":"10.4","height":"12.4","stroke":"currentColor","strokeWidth":"1.6","key":1})]);
}

CopyInline.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = CopyInline;

CopyInline.default = CopyInline;
